import { render, staticRenderFns } from "./IdentificationStatus.html?vue&type=template&id=5a327bee&scoped=true&"
import script from "./IdentificationStatus.vue?vue&type=script&lang=js&"
export * from "./IdentificationStatus.vue?vue&type=script&lang=js&"
import style0 from "./IdentificationStatus.scss?vue&type=style&index=0&id=5a327bee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a327bee",
  null
  
)

export default component.exports